import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "flex max-h-[92vh] flex-col overflow-hidden rounded-2xl bg-slate-100 shadow-2xl"
};
const _hoisted_2 = {
  class: "flex items-center justify-between border-b border-slate-200 bg-white px-5 py-3"
};
const _hoisted_3 = {
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_4 = {
  class: "flex items-start justify-center gap-6 overflow-auto p-6"
};
const _hoisted_5 = {
  class: "mp-article-area"
};
const _hoisted_6 = {
  class: "mp-title-row"
};
const _hoisted_7 = {
  class: "mp-article-title"
};
const _hoisted_8 = {
  class: "mp-meta-row"
};
const _hoisted_9 = {
  class: "mp-meta-inner"
};
const _hoisted_10 = {
  key: 0,
  class: "mp-meta-source"
};
const _hoisted_11 = {
  key: 1,
  class: "mp-meta-dot"
};
const _hoisted_12 = {
  key: 2,
  class: "mp-meta-text"
};
const _hoisted_13 = {
  class: "mp-meta-text"
};
const _hoisted_14 = {
  key: 0,
  class: "mp-tags-row"
};
const _hoisted_15 = {
  class: "mp-tag-badge-text"
};
const _hoisted_16 = {
  key: 1,
  class: "mp-hero-wrap"
};
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = {
  key: 2,
  class: "mp-body-paragraph"
};
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = {
  class: "w-64 shrink-0"
};
const _hoisted_21 = {
  class: "rounded-xl border border-slate-200 bg-white p-3"
};
const _hoisted_22 = {
  class: "mp-news-card"
};
const _hoisted_23 = {
  key: 0,
  class: "mp-news-featured"
};
const _hoisted_24 = ["src", "alt"];
const _hoisted_25 = {
  class: "mp-news-featured-overlay"
};
const _hoisted_26 = {
  class: "mp-news-featured-title"
};
const _hoisted_27 = {
  key: 1,
  class: "mp-news-featured mp-news-featured-empty"
};
const _hoisted_28 = {
  class: "mp-news-top-list"
};
const _hoisted_29 = {
  class: "mp-news-top-item"
};
const _hoisted_30 = {
  class: "mp-news-top-info"
};
const _hoisted_31 = {
  class: "mp-news-top-title"
};
const _hoisted_32 = {
  class: "mp-news-top-meta"
};
const _hoisted_33 = {
  class: "mp-news-rank-badge mp-news-rank-placeholder"
};
const _hoisted_34 = {
  class: "mp-news-rank-num"
};
const _hoisted_35 = {
  class: "rounded-xl border border-slate-200 bg-white p-4"
};
const _hoisted_36 = {
  class: "mp-list-item"
};
const _hoisted_37 = {
  class: "mp-list-content"
};
const _hoisted_38 = {
  class: "mp-list-title"
};
const _hoisted_39 = {
  class: "mp-list-meta"
};
const _hoisted_40 = {
  class: "mp-list-meta-left"
};
const _hoisted_41 = {
  key: 0,
  class: "mp-list-tag"
};
const _hoisted_42 = {
  class: "mp-list-tag-text"
};
const _hoisted_43 = {
  class: "mp-list-time"
};
const _hoisted_44 = {
  class: "mp-list-views"
};
const _hoisted_45 = {
  class: "mp-view-count"
};
const _hoisted_46 = ["src", "alt"];
const _hoisted_47 = {
  class: "rounded-xl border border-slate-200 bg-white p-3"
};
const _hoisted_48 = {
  class: "mp-banner-content"
};
const _hoisted_49 = {
  key: 0,
  class: "mp-banner-tag"
};
const _hoisted_50 = {
  class: "mp-banner-title"
};
const _hoisted_51 = {
  class: "mp-banner-subtitle"
};
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getArticleDetail } from '@/api/kb';
import MpPhoneFrame from '@/components/MpPhoneFrame.vue';
export default {
  __name: 'ArticlePreviewModal',
  props: {
    // 控制显示
    modelValue: {
      type: Boolean,
      default: false
    },
    // 已保存资讯：传资讯ID，组件自动加载详情
    articleId: {
      type: [String, Number],
      default: null
    },
    // 编辑中未保存内容：直接传入表单快照，无需请求接口
    // 形状：{ title, author, summary, content, coverImage（已解析URL）, categoryName, tags, isTop }
    previewData: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const status = ref(null);
    const info = reactive({
      title: '',
      author: '',
      publishTime: '',
      viewCount: 0,
      tags: [],
      coverImage: '',
      summary: '',
      content: '',
      isTop: false,
      categoryName: ''
    });
    const hintText = computed(() => {
      if (props.previewData) {
        return '预览当前编辑内容（包含未保存的修改）';
      }
      return {
        0: '当前为草稿，发布后对外生效',
        1: '当前展示为线上生效内容',
        2: '该资讯已下架，小程序端不可见'
      }[status.value] || '当前展示为线上生效内容';
    });
    const close = () => emit('update:modelValue', false);

    /** 与小程序 formatDate 保持一致：YYYY-MM-DD */
    const formatFullDate = dateStr => {
      if (!dateStr) return '';
      const d = new Date(String(dateStr).replace(/-/g, '/'));
      if (Number.isNaN(d.getTime())) return String(dateStr);
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day}`;
    };

    /** 与小程序首页热门资讯 formatDate 保持一致：MM-DD */
    const formatShortDate = dateStr => {
      if (!dateStr) return '';
      const d = new Date(String(dateStr).replace(/-/g, '/'));
      if (Number.isNaN(d.getTime())) return String(dateStr);
      return `${d.getMonth() + 1}-${d.getDate()}`;
    };

    /** 与小程序资讯列表 formatViews 保持一致 */
    const formatViews = count => {
      if (!count && count !== 0) return '0';
      if (count >= 10000) return (count / 10000).toFixed(1) + 'w';
      if (count >= 1000) return (count / 1000).toFixed(1) + 'k';
      return String(count);
    };

    /** 与小程序资讯列表 formatTime 保持一致：相对时间 */
    const formatRelativeTime = dateStr => {
      if (!dateStr) return '';
      const d = new Date(String(dateStr).replace(/-/g, '/'));
      if (Number.isNaN(d.getTime())) return String(dateStr);
      const diff = Date.now() - d.getTime();
      const minute = 60 * 1000;
      const hour = 60 * minute;
      const day = 24 * hour;
      if (diff < minute) return '刚刚';
      if (diff < hour) return Math.floor(diff / minute) + '分钟前';
      if (diff < day) return Math.floor(diff / hour) + '小时前';
      if (diff < 30 * day) return Math.floor(diff / day) + '天前';
      return `${d.getMonth() + 1}-${d.getDate()}`;
    };

    // 首页热门卡 meta 日期（previewData 无发布时间时占位）
    const shortDateText = computed(() => formatShortDate(info.publishTime) || '--');

    // 列表卡相对时间（previewData 模式显示「刚刚」）
    const relativeTimeText = computed(() => {
      if (props.previewData && !info.publishTime) return '刚刚';
      return formatRelativeTime(info.publishTime) || '刚刚';
    });

    // 与小程序一致：来源 = categoryName || tags[0] || '资讯'
    const sourceText = computed(() => info.categoryName || info.tags[0] || '资讯');

    // 横幅背景：有封面用封面，无封面用占位渐变
    const bannerStyle = computed(() => info.coverImage ? {
      backgroundImage: `url('${info.coverImage}')`
    } : {
      backgroundImage: 'linear-gradient(135deg, #475569 0%, #1e293b 100%)'
    });

    /** 与页面 getImageUrl 一致：相对路径拼接 API 基础地址 */
    const resolveCoverUrl = url => {
      if (!url) return '';
      if (/^(https?:|blob:|data:)/i.test(url)) return url;
      return `${process.env.VUE_APP_API_BASE_URL || ''}/${url}`.replace(/\/+/g, '/').replace(':/', '://');
    };

    /** 统一映射为小程序 article 结构 */
    const fillInfo = raw => {
      info.title = raw.title || '';
      info.author = raw.author || '';
      info.publishTime = raw.publishTime || '';
      info.viewCount = raw.viewCount ?? 0;
      info.tags = Array.isArray(raw.tags) ? raw.tags : raw.tags ? String(raw.tags).split(/,|，/).map(s => s.trim()).filter(Boolean) : [];
      info.coverImage = resolveCoverUrl(raw.coverImage);
      info.summary = raw.summary || '';
      info.content = raw.content || '';
      info.isTop = raw.isTop === 1 || raw.isTop === true;
      info.categoryName = raw.categoryName && raw.categoryName !== '-' ? raw.categoryName : '';
    };
    const loadDetail = async () => {
      loading.value = true;
      try {
        const data = await getArticleDetail(props.articleId);
        status.value = data?.status ?? null;
        fillInfo(data || {});
      } catch (error) {
        console.error('loadArticlePreview failed:', error);
        ElMessage.error(error.message || '加载资讯详情失败');
      } finally {
        loading.value = false;
      }
    };
    watch(() => props.modelValue, visible => {
      if (!visible) return;
      status.value = null;
      if (props.previewData) {
        fillInfo(props.previewData);
      } else if (props.articleId) {
        loadDetail();
      }
    });
    return (_ctx, _cache) => {
      return __props.modelValue ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4",
        onClick: _withModifiers(close, ["self"])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_cache[0] || (_cache[0] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "小程序预览", -1)), _createElementVNode("p", _hoisted_3, _toDisplayString(hintText.value), 1)]), _createElementVNode("button", {
        onClick: close,
        class: "rounded-full p-1 text-slate-400 hover:text-slate-600",
        "aria-label": "关闭预览"
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
        class: "h-5 w-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])]), _createElementVNode("div", _hoisted_4, [_createVNode(MpPhoneFrame, {
        title: "资讯详情",
        loading: loading.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(info.title), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "mp-fav-btn"
        }, [_createElementVNode("span", {
          class: "mp-icon mp-icon-star"
        })], -1))]), _createElementVNode("div", _hoisted_8, [_cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "mp-meta-accent"
        }, null, -1)), _createElementVNode("div", _hoisted_9, [info.author ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(info.author), 1)) : _createCommentVNode("", true), info.author && info.publishTime ? (_openBlock(), _createElementBlock("span", _hoisted_11)) : _createCommentVNode("", true), info.publishTime ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(formatFullDate(info.publishTime)), 1)) : _createCommentVNode("", true), _cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "mp-meta-dot"
        }, null, -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(info.viewCount) + "次阅读", 1)])]), info.tags.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.tags, (tag, idx) => {
          return _openBlock(), _createElementBlock("span", {
            key: idx,
            class: "mp-tag-badge"
          }, [_createElementVNode("span", _hoisted_15, _toDisplayString(tag), 1)]);
        }), 128))])) : _createCommentVNode("", true), info.coverImage ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("img", {
          class: "mp-hero-image",
          src: info.coverImage,
          alt: info.title
        }, null, 8, _hoisted_17)])) : _createCommentVNode("", true), info.summary ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(info.summary), 1)) : _createCommentVNode("", true), info.content ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "mp-rich-content",
          innerHTML: info.content
        }, null, 8, _hoisted_19)) : _createCommentVNode("", true)]), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "mp-footer-section"
        }, [_createElementVNode("div", {
          class: "mp-footer-line"
        }), _createElementVNode("span", {
          class: "mp-footer-text"
        }, [_createTextVNode("本文仅代表作者观点，不代表平台立场。"), _createElementVNode("br"), _createTextVNode("内容仅供参考，不作为法律依据。")])], -1))]),
        _: 1
      }, 8, ["loading"]), _createElementVNode("div", _hoisted_20, [_cache[12] || (_cache[12] = _createElementVNode("p", {
        class: "mb-2 text-xs font-medium text-slate-500"
      }, "首页\"热门资讯\"卡片", -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [info.coverImage ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("img", {
        class: "mp-news-featured-img",
        src: info.coverImage,
        alt: info.title
      }, null, 8, _hoisted_24), _createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(info.title || '-'), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", null, "无封面时首页热门位不展示大图", -1)]))])), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "mp-news-rank-badge rank-1"
      }, [_createElementVNode("span", {
        class: "mp-news-rank-num"
      }, "1")], -1)), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(info.title || '-'), 1), _createElementVNode("span", _hoisted_32, _toDisplayString(shortDateText.value) + " · " + _toDisplayString(sourceText.value), 1)])]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, i => {
        return _createElementVNode("div", {
          key: i,
          class: "mp-news-top-item opacity-40"
        }, [_createElementVNode("span", _hoisted_33, [_createElementVNode("span", _hoisted_34, _toDisplayString(i + 1), 1)]), _cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "mp-news-top-info"
        }, [_createElementVNode("span", {
          class: "mp-news-top-title text-slate-300"
        }, "其他资讯"), _createElementVNode("span", {
          class: "mp-news-top-meta"
        }, "-- · 资讯")], -1))]);
      }), 64))])])]), _cache[13] || (_cache[13] = _createElementVNode("p", {
        class: "mb-2 mt-4 text-xs font-medium text-slate-500"
      }, "资讯列表卡片", -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString(info.title || '-'), 1), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [sourceText.value ? (_openBlock(), _createElementBlock("span", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(sourceText.value), 1)])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_43, _toDisplayString(relativeTimeText.value), 1)]), _createElementVNode("div", _hoisted_44, [_cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "mp-icon mp-icon-eye view-icon"
      }, null, -1)), _createElementVNode("span", _hoisted_45, _toDisplayString(formatViews(info.viewCount)), 1)])])]), info.coverImage ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "mp-list-image",
        src: info.coverImage,
        alt: info.title
      }, null, 8, _hoisted_46)) : _createCommentVNode("", true)])]), _cache[14] || (_cache[14] = _createElementVNode("p", {
        class: "mb-2 mt-4 text-xs font-medium text-slate-500"
      }, "资讯列表\"重磅推荐\"横幅（置顶时展示徽标）", -1)), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
        class: "mp-banner",
        style: _normalizeStyle(bannerStyle.value)
      }, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "mp-banner-gradient"
      }, null, -1)), _createElementVNode("div", _hoisted_48, [info.isTop ? (_openBlock(), _createElementBlock("span", _hoisted_49, [...(_cache[10] || (_cache[10] = [_createElementVNode("span", {
        class: "mp-banner-tag-text"
      }, "重磅推荐", -1)]))])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_50, _toDisplayString(info.title || '-'), 1), _createElementVNode("span", _hoisted_51, _toDisplayString(info.summary || ''), 1)])], 4)]), _cache[15] || (_cache[15] = _createElementVNode("p", {
        class: "mt-2 text-xs leading-5 text-slate-400"
      }, "热门资讯卡展示封面、标题与来源；列表卡按有无封面自动切换图文/纯文本形态；正文图片以宽度自适应展示。", -1))])])])])) : _createCommentVNode("", true);
    };
  }
};